import { gql } from "graphql-request"

const filecoin = {
    name: 'filecoin',
    title: 'Filecoin Mainnet',
    currency: 'FIL',
    check: true,
    regexp: '([\\W]|^)(f[0-9]{1,14})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        filecoin(network: filecoin) {
            address(address: {is: $address}) {
                balance: balance
                balance_usd: balance(in: USD)
            }
            ins: transfers(receiver: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            outs: transfers(sender: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
        }
    }`,
    checkAddress: 'f0133235',
}
export { filecoin }
